import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http'

const state: ServiceRequestState = {
  activeServiceRequest: {}
}

const getters: GetterTree<ServiceRequestState, RootState> = {

}

const actions: ActionTree<ServiceRequestState, RootState> = {
  create({ commit }, payload) {
    return http.v1.sr.create(payload).then(response => {
      if (response.data.data) {
        commit('SET_ACTIVE_SERVICE_REQUEST', response.data.data)
      }
    }).catch(error => {
      console.log(error)
    })
  },
  fetch({ commit }, oid) {
    return http.v1.sr.fetch(oid, {
      params: {
        expand: [
          'service_candidates.booking_candidate',
          'service_candidates.service_item'
        ],
        with_booking_candidates: 1
      }
    }).then(response => {
      if (response.data.data) {
        commit('SET_ACTIVE_SERVICE_REQUEST', response.data.data)
      }
    }).catch(error => {
      console.log(error)
    })
  },
  fetchList(context, options) {
    return http.v1.sr.fetchList(options).then(({ data }) => {
      const payload = data
      const items = payload.data.data
      return {
        items,
        total: payload.data.total,
      }
    })
  },
  consume({ state }) {
    return http.v1.sr.consume(state.activeServiceRequest.object_id)
  },
  checkCreditLimit({ state }) {
    return http.v1.sr.checkCreditLimit(state.activeServiceRequest.object_id)
  },
}

const mutations: MutationTree<ServiceRequestState> = {
  SET_ACTIVE_SERVICE_REQUEST (state, activeServiceRequest) {
    state.activeServiceRequest = activeServiceRequest
  },
  CLEAR_STATE (state) {
    state.activeServiceRequest = {}
  },
}

const serviceRequest: Module<ServiceRequestState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default serviceRequest